import { noop } from 'lodash'
import { useEffect } from 'react'
import { useRouteManagerApiPollingValue } from 'containers/new-route-manager/common/RouteManagerApiPollingProvider'

export const useHandleRouteManagerApiPolling = isOpen => {
  const { handlePausePolling = noop, handleResumePolling = noop } = useRouteManagerApiPollingValue() || {}

  useEffect(() => {
    if (!isOpen) return

    handlePausePolling()
    return () => handleResumePolling()
  }, [isOpen])
}
